export default __webpack_public_path__ + "static/media/upload_portal_logo.f37afdbe.png";